import $ from 'jquery';
import { gsap } from 'gsap';
import { Observer } from 'gsap/dist/Observer';
// import Function from './_Function.js';
// import Op from '../Window/_OpResize.js';
// import Hebi from '../Window/_HebiResize.js';
// import Text from '../Window/_TextResize.js';
import { ManagePage } from '../Manage/_ManagePage.js';
gsap.registerPlugin(Observer);


export default class Scroll {
  constructor() {

    Observer.create({
      target: window,
      type: 'wheel',
      onUp: () => previous(),
      onDown: () => next(),
    });

    Observer.create({
      target: window,
      type: 'touch',
      onUp: () => next(),
      onDown: () => previous(),
    });


    function previous() {
      // console.log("🚀 ~ previous ~ previous:")
      if(!ManagePage.getCurrentPageNum()) return false; //オープニングはスクロールさせない

      // シーン７（スクロール可能な最後のメッセージ）は　シーン５に飛ばす
      if(ManagePage.getCurrentPageNum() == 7 && $(window).scrollTop() <= 0) {

        ManagePage.setPage(5);
      } else {
        ManagePage.gotoPrevPage();
      }

    }

    function next() {
      // console.log("🚀 ~ next ~ next:"+ManagePage.getCurrentPageNum())
      if(!ManagePage.getCurrentPageNum() || ManagePage.getCurrentPageNum() == 7) return false; //オープニングとENDはスクロールさせない
      ManagePage.gotoNextPage();
    }

    // gsap.to('.block--2', {
    //   scrollTrigger: {
    //     trigger: '.block--2',
    //     start: 'top top',
    //     markers: true,
    //   }
    // });


    // let b1 = $('.block--1').offset().top;
    // let b2 = $('.block--2').offset().top;
    // let b3 = $('.block--3').offset().top;
    // let b4 = $('.block--4').offset().top;
    // let b5 = $('.block--5').offset().top;
    // let b6 = $('.block--6').offset().top;

    // $(window).on('scroll', function(){
    //   const scroll = $(window).scrollTop();
    //   if (scroll >= b1 && scroll < b2) {
    //     console.log("🚀 ~ $ ~ scroll: 1");
    //     ManagePage.setPage(1);
    //   } else if (scroll >= b2 && scroll < b3) {
    //     console.log("🚀 ~ $ ~ scroll: 2");
    //     ManagePage.setPage(2);
    //   } else if (scroll >= b3 && scroll < b4) {
    //     console.log("🚀 ~ $ ~ scroll: 3");
    //     ManagePage.setPage(3);
    //   }
    // });

    // let scrollTimer = false;

    // addEventListener('mousewheel', (event) => {

    //   // if (event.deltaY > 0) {
    //   //   console.log("down");
    //   //   ManagePage.gotoNextPage();
    //   // } else {
    //   //   console.log("up");
    //   //   ManagePage.gotoPrevPage();
    //   // }


    //   // if (scrollTimer !== false) {
    //   //   clearTimeout(scrollTimer);
    //   // }

    //   // scrollTimer = setTimeout(function () {
    //   //   if (event.deltaY > 0) {
    //   //     console.log("down");
    //   //     ManagePage.gotoNextPage();
    //   //   } else {
    //   //     console.log("up");
    //   //     ManagePage.gotoPrevPage();
    //   //   }
    //   // }, 200);

    // });
  }
}

// (() => {})();
